<template>
    <v-container fill-height fluid>
        <v-row align="center" justify="center">
            <v-col>
                <div
                    class="mx-auto"   
                >
                    <v-list-item three-line style="padding:50px">
                        <v-img
                            src="img/logo.png" 
                        ></v-img>    
                    </v-list-item> 
                    <v-list-item three-line :style="heightTop">
                        <v-row justify="center">
                            <v-col
                                class="d-flex"
                                cols="12"
                                sm="12"
                            >
                                <v-combobox
                                    v-model="selected"
                                    :items="signatures"
                                    label="Assinatura"
                                    outlined
                                    rounded
                                >
                                </v-combobox>
                            </v-col>
                        </v-row>
                    </v-list-item>
                    <v-card-actions :style="heightBottom">
                        <v-row>
                            <v-col
                                cols="12"
                                sm="12"
                            >
                                <v-btn
                                    depressed
                                    color="primary"
                                    rounded
                                    block
                                    style="color:white"
                                    @click="next"
                                >
                                    Próximo
                                </v-btn>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                            >
                                <v-btn
                                    color="#f5f5f5 !important"
                                    depressed
                                    rounded
                                    block
                                    @click="back"
                                >
                                    Voltar
                                </v-btn>
                            </v-col>
                            <v-col
                            cols="12"
                            sm="12"
                            align="right" 
                            style="color:#378bac;"
                        >
                                <h6 >by Plataforma SIG</h6>  
                                    </v-col>
                        </v-row>
                    </v-card-actions>
                </div>
            </v-col>
        </v-row>
        <v-dialog
            v-model="dialog.show"
            max-width="290"
        >
            <v-card>
                <v-card-title class="headline">
                    {{dialog.title}}
                </v-card-title>

                <v-card-text>
                    {{dialog.message}}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                        color="green darken-1"
                        text
                        @click="dialog.show = false"
                    >
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import CrudService from '../../services/CrudService';

export default {
    data: () => ({
        heightTop: "margin-top:100px",
        heightBottom: "padding-bottom:50px",
        signatures: [],
        selected: "",
        dialog: {
            show: false,
            title: '',
            message: ''
        }
    }),

    created(){
        let loginData = JSON.parse(localStorage.getItem("loginData"));

        if(loginData != null)
        {
            let canDemands = loginData.permissionAndMenu.find(permission => {
                return permission.menuId == 27
            });

            if(!(canDemands != null || loginData.userData.userType == 2))
                this.$router.push('menu');
            else
                this.$router.push('kpis');
        }
    },

    methods: {
        next(){
            if(!isNaN(this.selected.value))
                this.$router.push({name: 'Password', params: {login: this.$route.params.login, signature: this.selected.value}});
            else
            {
                this.dialog.title = "Atenção";
                this.dialog.message = "Escolha uma assinatura";
                this.dialog.show = true;
            }
        },
        back(){
            this.$router.push('/');
        }
    },
    async beforeCreate(){
        let loader = this.$loading.show();

        try
        {
            let crudService = new CrudService();
            let result = await crudService.get(`auth/getSignatures?email=${this.$route.params.login}`);

            if(result.status == 200)
            {
                result.data.map(obj => {
                    this.signatures.push({
                        text: obj.name,
                        value: obj.signatureId
                    })
                });
            }
            loader.hide();
        }
        catch
        {
            loader.hide();
            this.dialog.title = "Erro";
            this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
            this.dialog.show = true;
        }
    }
}
</script>